import { atomWithStorage } from 'jotai/utils'
import { createStringStorage } from './generics'

export type Theme = 'light' | 'dark'

const stringStorage = createStringStorage<Theme>()

/* A pre-paint bootstrap script (the app's public/theme.js) may have already
   applied the stored theme to the document element before any bundle code
   runs. Reading that applied class first keeps the atom's first render in
   agreement with what is already painted; storage is the fallback for
   documents no bootstrap script touched. */
const appliedThemeStorage: typeof stringStorage = {
  ...stringStorage,
  getItem: (key, initialValue) => {
    if (typeof document === 'undefined') return initialValue

    const applied = document.documentElement.classList
    if (applied.contains('light')) return 'light'
    if (applied.contains('dark')) return 'dark'

    return stringStorage.getItem(key, initialValue)
  }
}

export const themeAtom = atomWithStorage<Theme>(
  'theme',
  'dark',
  appliedThemeStorage,
  // Resolve the initial value at creation instead of after mount, so the
  // first render already reflects the applied or stored theme.
  { getOnInit: true }
)
